import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { TimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import { useChartEffectTickFormatter } from 'src/hooks/useEffectFormatter';
import { MonthYearDateFormatter } from 'src/utils/TickFormatters';
import { LONG_TERM_EFFECT_DEF } from 'src/utils/metricDefinitions';
import { useLTDataContext } from '../../contexts/LTDataContext';

const title = 'Long term effect';

export const LongTermEffectOTBox: React.FC = () => {
  const { effects, isError, isLoading } = useLTDataContext();
  const valueTickFormatter = useChartEffectTickFormatter();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return effects.monthly.map((x) => ({
      utcEpoch: x.utcEpoch,
      value: x.longTermMediaEffect,
    }));
  }, [effects]);

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel={title}
      data={data}
      xAxisFormatter={MonthYearDateFormatter}
      yAxisFormatter={valueTickFormatter}
      isError={isError}
      isLoading={isLoading}
      infoText={LONG_TERM_EFFECT_DEF}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={valueTickFormatter}
          dateFormatter={MonthYearDateFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
